/**
 * Smooth scrolling (Lenis) — Theme Blueprint
 * ---------------------------------------------------------------------------
 * Initialises Lenis globally on every page. Touch stays native (best on
 * mobile); only wheel scrolling is smoothed. Respects prefers-reduced-motion.
 * Exposes `window.lenis` so overlays (mini cart) can stop/start it.
 */
(function () {
  "use strict";

  if (typeof Lenis === "undefined") return;
  if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  var lenis = new Lenis({
    lerp: 0.1,
    smoothWheel: true,
    wheelMultiplier: 1,
    syncTouch: false,
    touchMultiplier: 1.5,
    anchors: true
  });

  window.lenis = lenis;

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);
})();
